<div class="app-version">
  <small>{{appVersion}}</small>
</div>
